import AppRouter from "./router/router.tsx";
import React from "react";

function App() {
  return <AppRouter />;
}

export default App;
